/* eslint react/prop-types: 0 */
import React from 'react';
import { injectIntl } from 'react-intl';
import { moduleMessageId } from '../../helpers/traceability/modulePorts';
import PortSticker from './PortSticker';
import PortsIllustration from './PortsIllustration';
import './boardModules.scss';

/**
 * Avisa que un módulo está enchufado en un puerto que no lo acepta, y en cuáles
 * sí funciona.
 *
 * `misplaced` es lo que devuelve misplacedModule ({ label, name, ports }), con la
 * lectura en `reading`. Se muestra desde el estado de React, como los demás
 * modales de la placa (ver InstallFirmwareModal).
 */
const MisplacedModuleModal = ({ board, misplaced, intl, onClose }) => {
  if (!misplaced) return null;

  const messageId = moduleMessageId(misplaced.reading);
  const module = intl.formatMessage({ id: messageId || 'blocks.blockly.boardModules.unknownModule' });

  return (
    <>
      <div className="modal-backdrop show" />
      <div
        className="modal fade show misplacedModuleModal"
        role="dialog"
        aria-modal="true"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {intl.formatMessage({ id: 'blocks.blockly.boardModules.misplacedTitle' })}
              </h5>
            </div>
            <div className="modal-body">
              <PortsIllustration />
              <div className="texts">
                <p className="line">
                  <span>
                    {intl.formatMessage(
                      { id: 'blocks.blockly.boardModules.misplacedMessage' },
                      { module, b: (chunks) => <strong>{chunks}</strong> },
                    )}
                  </span>
                  <PortSticker board={board} label={misplaced.label} state="wrong" />
                </p>
                <p className="line">
                  <span>
                    {intl.formatMessage({
                      id: misplaced.ports.length > 0
                        ? 'blocks.blockly.boardModules.misplacedSolution'
                        : 'blocks.blockly.boardModules.misplacedNoPorts',
                    })}
                  </span>
                  {misplaced.ports.map((label) => (
                    <PortSticker key={label} board={board} label={label} state="right" />
                  ))}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="agree" onClick={onClose}>
                {intl.formatMessage({ id: 'common.agreed' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(MisplacedModuleModal);
